<template>
	<div class="pages">
		<div class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill"></div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="标题..." @handleSearch="handleOffset(0)"></z-search></div>
			
		</div>
		<section>
			<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in list.list || []">
					<td>{{item.title}}</td>
					<td>{{item.c_time | momentFmt}}</td>
					<td class="operating">
						<router-link class="operat-btn" :to="{ name: 'mgMessageEdit' ,query:{id:item.id}}"><i class="icon-edit"></i><span>编辑</span></router-link>
						<el-popover placement="top" width="200" :ref="'popover_'+index">
							<div class="z-popover">
								<div>确认要删除此条消息?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleDeleteBtn(item.id)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-del"></i><span>删除</span></a>
						</el-popover>
					</td>
				</tr>
				<div slot="operate">
					<router-link class="z-btn z-btn-primary b-r-3" :to="{ name: 'mgMessageEdit'}">发布消息</router-link>
				</div>
			</z-table>

		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'BusinessManage',
		components: {},
		data() {
			return {
				defaultPic: require('@/assets/img/logo_def.png'),
				columns: ['标题','创建时间', '操作'],
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
					search: '',//查询字符串
				}
			}
		},
		mounted() {
			this.handleGetMgMessaList();
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				list: state => state.message.list
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			//处理分页
			handleOffset(offset) {
				this.params.offset = offset;
				this.handleGetMgMessaList();
			},
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_' + index]) != "undefined") this.$refs['popover_' + index][0].doClose();
			},
			//删除
			async handleDeleteBtn(id) {
				try{
					await this.delMgMgMessage({id}) 
					this.handleGetMgMessaList()
					this.$success('删除成功')
				}catch(e){
					this.$errorMsg('删除失败')
				}
			},
			//获取门店列表
			async handleGetMgMessaList() {
				await this.getMgMessageList(this.params)
			},
			...mapActions(['getMgMessageList','delMgMgMessage']),
		}
	}
</script>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
</style>


// WEBPACK FOOTER //
// MessageList.vue?cb5b0838